var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import DesktopOnlyNoticeImage from '@backrs_ui/common-ui/src/assets/images/desktop-only-notice.png';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Typography, Stack, Button } from '@mui/material';
var desktopOnlyNotice = appStrings.modules.desktopOnlyNotice;
export var DesktopOnlyNotice = function () {
    var copyLink = function () {
        navigator.clipboard.writeText(location.href);
    };
    return (_jsxs(Box, { sx: wrapperStyle, children: [_jsx(Box, { sx: overlayStyle }), _jsx(Box, { sx: cardWrapperStyle, children: _jsx(Box, { sx: cardStyle, children: _jsxs(Stack, { sx: containerStyle, children: [_jsx(Box, { component: "img", src: DesktopOnlyNoticeImage, sx: imageStyle }), _jsxs(Stack, { sx: bodyStyle, children: [_jsx(Typography, { variant: "text-lg-semibold", sx: titleStyle, children: desktopOnlyNotice.title }), _jsx(Typography, { variant: "text-sm-regular", sx: descriptionStyle, children: desktopOnlyNotice.description })] }), _jsx(Button, { startIcon: _jsx(AppIcon, { iconName: "Copy01", diameter: "20px", color: "Colors/Foreground/fg-secondary" }), sx: buttonStyle, onClick: copyLink, children: desktopOnlyNotice.copyLink })] }) }) })] }));
};
var wrapperStyle = {
    width: '100%',
    height: '100%',
    position: 'relative',
};
var overlayStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        height: '100%',
        backgroundColor: backrs.colors['Colors/Base/Black'],
        opacity: 0.2,
        position: 'absolute',
        top: 0,
        left: 0,
    });
};
var cardWrapperStyle = __assign(__assign({}, wrapperStyle), { display: 'grid', placeItems: 'center' });
var cardStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        overflow: 'hidden',
        border: '1px solid black',
        borderRadius: backrs.radius['radius-xl'],
        backgroundColor: backrs.colors['Colors/Background/bg-primary'],
        marginLeft: backrs.spacing['spacing-xl'],
        marginRight: backrs.spacing['spacing-xl'],
        padding: backrs.spacing['spacing-xl'],
        boxShadow: backrs.shadows['shadow-xl'],
        transform: 'translate(-2px, -2px)',
        '&:active': {
            outline: 'none',
            transform: 'translate(0px, 0px)',
            boxShadow: 'none',
            transition: 'all 0s',
        },
        fontFamily: 'Sarabun, sans-serif',
        maxWidth: '375px',
    });
};
var containerStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        rowGap: backrs.spacing['spacing-3xl'],
    });
};
var bodyStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        rowGap: backrs.spacing['spacing-md'],
        alignItems: 'center',
        textAlign: 'center',
    });
};
var imageStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        objectFit: 'cover',
        borderRadius: backrs.radius['radius-md'],
    });
};
var titleStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-primary'],
        fontFamily: 'inherit',
    });
};
var descriptionStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-tertiary'],
        fontFamily: 'inherit',
        maxWidth: '310px',
    });
};
var buttonStyle = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign({ width: '100%', color: backrs.colors['Colors/Foreground/fg-secondary'], border: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-secondary']), borderRadius: backrs.radius['radius-md'], fontFamily: 'inherit', textTransform: 'capitalize' }, typography['text-md-semibold']));
};
